import React from 'react';
import { useDetailsModal } from '../context/DetailsModalContext';
import { LINK_TEXT } from '../utils/clickable';

// A loan code (or an amount belonging to a loan) that opens the loan's
// details. Pass the loan object when it is on screen, or just its id.
// `onOpen` replaces the default (the page's own details view, if it has one).
const LoanLink = ({ loan, loanId, children, className = '', title, onOpen }) => {
  const { openLoan, canViewLoans, isClientUser } = useDetailsModal();
  const id = loan?.id ?? loanId;
  const label = children ?? loan?.loan_code ?? loan?.loanCode ?? (id ? `Loan #${id}` : '-');
  if (!id || (!onOpen && !canViewLoans && !isClientUser)) return <span className={className}>{label}</span>;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (onOpen) onOpen(loan || { id });
        else openLoan(loan || id);
      }}
      className={`${LINK_TEXT} text-left p-0 bg-transparent border-0 ${className}`}
      title={title || 'Open loan details'}
    >
      {label}
    </button>
  );
};

export default LoanLink;
